module.exports = __webpack_public_path__ + "img/logo-icon.f1ee1eec.svg";